import React from 'react'

import { useGoogleLogin } from '@react-oauth/google'

import { useGoogleSignInMutation } from '~/app/generated/graphql'
import { gt } from '~/lib/gt'

import { RegisterSignInCallback } from '../AuthModals/RegisterModal/RegisterModalView'
import LoginButton from '../LoginButton'

export type GoogleLoginButtonProps = {
  onLogin?: RegisterSignInCallback
  label?: string
}

const GoogleLoginButtonView: React.FC<GoogleLoginButtonProps> = ({ label, onLogin }) => {
  const [googleSignIn] = useGoogleSignInMutation()
  const { tp } = gt

  const login = useGoogleLogin({
    onSuccess: async response => {
      try {
        const accessToken = response.access_token
        const result = await googleSignIn({
          variables: {
            accessToken,
          },
        })
        if (onLogin) {
          onLogin(result.data?.googleSignIn.user || null, true)
        }
      } catch (e) {}
    },
    flow: 'implicit',
  })

  return <LoginButton icon='google' label={label ?? tp('Login', 'Sign with Google')} onClick={() => login()} />
}

export default GoogleLoginButtonView
